(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return "$" + v;
  }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = $("[data-toast]");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2400);
  }

  /* ---------------- drawer ---------------- */
  var drawer = $("[data-cart-drawer]");
  var overlay = $("[data-overlay]");
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    overlay.classList.add("open");
    refreshCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    overlay.classList.remove("open");
  }
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", openDrawer); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  if (overlay) overlay.addEventListener("click", function () { closeDrawer(); closeMenu(); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeDrawer(); closeMenu(); closeSearch(); }
  });

  /* ---------------- cart state ---------------- */
  function renderCart(cart) {
    var count = $("[data-cart-count]");
    if (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    }
    var sub = $("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
    var co = $("[data-checkout]");
    if (co) co.disabled = cart.item_count === 0;

    var bar = $("[data-ship-bar]");
    var msg = $("[data-ship-msg]");
    var subA = cart.total_price / 100;
    if (bar) bar.style.width = Math.min(100, subA) + "%";
    if (msg) {
      msg.textContent = cart.item_count === 0
        ? "Free Australian shipping on orders over $100."
        : subA >= 100
          ? "You've unlocked free Australian shipping."
          : "Add " + money((100 - subA) * 100) + " more for free Australian shipping.";
    }

    var box = $("[data-cart-items]");
    if (!box) return;
    if (cart.item_count === 0) {
      box.innerHTML = '<div class="cart-empty">Your pack is empty.<br>The trail is waiting.</div>';
      return;
    }
    box.innerHTML = cart.items.map(function (i, idx) {
      var img = i.image ? i.image.replace(/(\.[a-z]{3,4})(\?|$)/, "_240x$1$2") : "";
      return '<div class="ci">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") +
        '<div class="ci-body">' +
          '<div class="ci-title">' + i.product_title + '</div>' +
          (i.variant_title && i.variant_title !== "Default Title" ? '<div class="ci-meta">' + i.variant_title + '</div>' : "") +
          '<button class="ci-remove" data-line-remove="' + (idx + 1) + '">Remove</button>' +
          '<div class="ci-row">' +
            '<div class="qty">' +
              '<button data-line-dec="' + (idx + 1) + '" aria-label="Decrease quantity">−</button>' +
              '<input type="text" value="' + i.quantity + '" readonly aria-label="Quantity">' +
              '<button data-line-inc="' + (idx + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="ci-price">' + money(i.final_line_price) + '</div>' +
          '</div>' +
        '</div></div>';
    }).join("");
  }

  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function changeLine(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var inc = e.target.closest("[data-line-inc]");
      var dec = e.target.closest("[data-line-dec]");
      var rem = e.target.closest("[data-line-remove]");
      if (inc) {
        var input = inc.parentElement.querySelector("input");
        changeLine(+inc.getAttribute("data-line-inc"), (+input.value) + 1);
      }
      if (dec) {
        var input2 = dec.parentElement.querySelector("input");
        changeLine(+dec.getAttribute("data-line-dec"), Math.max(0, (+input2.value) - 1));
      }
      if (rem) changeLine(+rem.getAttribute("data-line-remove"), 0);
    });
    var co = $("[data-checkout]");
    if (co) co.addEventListener("click", function () { window.location.href = "/checkout"; });
  }

  /* ---------------- AJAX add to cart ---------------- */
  $$('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "Could not add to cart"); });
          return r.json();
        })
        .then(function (item) {
          toast((item.product_title || "Item") + " added to your pack");
          openDrawer();
        })
        .catch(function (err) { toast(err.message); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        });
    });
  });

  /* ---------------- product page ---------------- */
  var pform = $("[data-product-form]");
  if (pform) {
    var variants = JSON.parse($("[data-variant-json]").textContent);
    var idInput = pform.querySelector('input[name="id"]');
    var priceEl = $("[data-pdp-price]");
    var compareEl = $("[data-pdp-compare]");
    var addBtn = pform.querySelector('[type="submit"]');

    function setVariant(v) {
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else compareEl.hidden = true;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to pack" : "Sold out";
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState(null, "", url.toString());
      }
    }

    $$(".size-btn").forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".size-btn").forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on");
        var v = variants.filter(function (x) { return String(x.id) === b.getAttribute("data-variant-id"); })[0];
        if (v) setVariant(v);
      });
    });

    var qtyInput = pform.querySelector('input[name="quantity"]');
    $$("[data-qty-inc],[data-qty-dec]").forEach(function (b) {
      b.addEventListener("click", function () {
        var d = b.hasAttribute("data-qty-inc") ? 1 : -1;
        qtyInput.value = Math.max(1, (+qtyInput.value || 1) + d);
      });
    });

    $$("[data-thumb]").forEach(function (b) {
      b.addEventListener("click", function () {
        $$("[data-thumb]").forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on");
        var main = $("[data-pdp-main] img");
        if (main) { main.src = b.getAttribute("data-src"); main.srcset = ""; }
      });
    });
  }

  /* ---------------- menus & search ---------------- */
  var mm = $("[data-mobile-menu]");
  function closeMenu() { if (mm) mm.hidden = true; }
  $$("[data-menu-open]").forEach(function (b) {
    b.addEventListener("click", function () { if (mm) mm.hidden = false; });
  });
  $$("[data-menu-close]").forEach(function (b) { b.addEventListener("click", closeMenu); });

  var sb = $("[data-search-bar]");
  function closeSearch() { if (sb) sb.hidden = true; }
  $$("[data-search-open]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (!sb) return;
      sb.hidden = !sb.hidden;
      if (!sb.hidden) { var i = sb.querySelector("input"); if (i) i.focus(); }
    });
  });
  $$("[data-search-close]").forEach(function (b) { b.addEventListener("click", closeSearch); });

  /* ---------------- collection sort ---------------- */
  var sort = $("[data-sort]");
  if (sort) {
    sort.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      window.location.href = url.toString();
    });
  }

  refreshCart();
})();
